import { Schema, TcpUdp } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const tcpUdp: Schema<TcpUdp> = {
  fields: [
    {
      name: "timestamp",
      displayTitle: "Timestamp",
      sortable: true,
      component: d => <>{d.timestamp}</>
    },
    {
      name: "srcport",
      displayTitle: "Source port",
      sortable: true,
      component: d => <>{d.srcport}</>
    },
    {
      name: "dstport",
      displayTitle: "Destination port",
      sortable: true,
      component: d => <>{d.dstport}</>
    },
    {
      name: "srcip",
      displayTitle: "Source IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.srcip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dstip",
      displayTitle: "Destination IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.dstip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    }
  ]
};
